export default [
  {
    value: "",
    label: ""
  },
  {
    value:
      "EPA Category: Mission Sensitive, NARA Category: Critical Infrastructure",
    label:
      "EPA Category: Mission Sensitive, NARA Category: Critical Infrastructure"
  },
  {
    value:
      "EPA Category: Drinking Water Vulnerability Assessments, NARA Category: Critical Infrastructure-Water Assessments",
    label:
      "EPA Category: Drinking Water Vulnerability Assessments, NARA Category: Critical Infrastructure-Water Assessments"
  },
  {
    value:
      "EPA Category: Sensitive Drinking Water Related, NARA Category: Critical Infrastructure-Water Assessments",
    label:
      "EPA Category: Sensitive Drinking Water Related, NARA Category: Critical Infrastructure-Water Assessments"
  },
  {
    value:
      "EPA Category: IT Security, NARA Category: Information Systems Vulnerability Information",
    label:
      "EPA Category: IT Security, NARA Category: Information Systems Vulnerability Information"
  },
  {
    value:
      "EPA Category: Law Enforcement Sensitive, NARA Category: Law Enforcement",
    label:
      "EPA Category: Law Enforcement Sensitive, NARA Category: Law Enforcement"
  },
  {
    value:
      "EPA Category: Attorney Client Privilege, NARA Category: Legal-Privilege",
    label:
      "EPA Category: Attorney Client Privilege, NARA Category: Legal-Privilege"
  },
  {
    value:
      "EPA Category: Attorney Work Product, NARA Category: Legal-Privilege",
    label: "EPA Category: Attorney Work Product, NARA Category: Legal-Privilege"
  },
  {
    value:
      "EPA Category: Deliberative Process Privilege, NARA Category: Legal-Privilege",
    label:
      "EPA Category: Deliberative Process Privilege, NARA Category: Legal-Privilege"
  },
  {
    value:
      "EPA Category: Personally Identifiable Information (PII), NARA Category: Privacy",
    label:
      "EPA Category: Personally Identifiable Information (PII), NARA Category: Privacy"
  },
  {
    value: "EPA Category: Proprietary, NARA Category: Proprietary",
    label: "EPA Category: Proprietary, NARA Category: Proprietary"
  },
  {
    value:
      "EPA Category: Confidential Business Information, NARA Category: Proprietary-Manufacturer",
    label:
      "EPA Category: Confidential Business Information, NARA Category: Proprietary-Manufacturer"
  },
  {
    value:
      "EPA Category: Source Selection Information, NARA Category: Proprietary-Source Selection",
    label:
      "EPA Category: Source Selection Information, NARA Category: Proprietary-Source Selection"
  }
];
